import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.module.scss';

const StickyNoteTooltip = ({canvasSVGObject}) => {

    if (!canvasSVGObject) {
        return null;
    }

    let text = canvasSVGObject.info.text.replace(/<[^>]+>/g, '');
    
    if(text.length > 10) {
        text = text.substring(0, 10) + '...';
    }
    if (text.length === 0) {
        return null
    }

    return (
        ReactDOM.createPortal(<div className={styles.stickyNoteTooltip} style={{ left: canvasSVGObject.info.position.x, top: canvasSVGObject.info.position.y + 50 }}>
            {text}
        </div>, document.body)
    );
}

export default StickyNoteTooltip;